import _ from 'lodash'
import { baseURL, formatFetchError, fetchHeaders } from '@/api/util'
import { Api, Vehicle } from '@cruz-com/lookup'

export async function inquiries(params: object): Promise<Api.Result<Vehicle.Lead[]>> {
  try {
    const res = await fetch(`${baseURL}/my/inquiries?${new URLSearchParams(params as Record<string, string>)}`, {
      method: 'GET',
      headers: await fetchHeaders(),
      next: { revalidate: 0 },
      cache: 'no-store'
    })
    const d = await res.json()
    if (!res.ok) {
      return Promise.reject(d)
    }
    return Promise.resolve(d)
  } catch (err) {
    return Promise.reject(formatFetchError(err))
  }
}